module.exports = __webpack_public_path__ + "img/presentation06.87aecf90.jpg";